import request from '@/services/interceptor.js'

export const genera_codice = () => {
    return request({
        url: '/timbratura/genera-codice',
        method: 'get',
        loadingBar: false
    })
}